/* Editorial Asset Foundry — Phase 1 wire-up.
   Single source of truth for the 10 AI-generated editorial photographs that
   ship with the Lumetier "Maison Model" visual overhaul. Every component
   imports the slug from this map instead of hardcoding a path so that
   swapping a single image is a one-file change.

   Naming: slug_with_underscores. Files live under /public/editorial/ so
   they're served directly by the frontend's static handler — no bundling,
   no opaque hashed filenames. Add `<link rel="preload">` for any hero use. */

const base = "/editorial";

export const EDITORIAL_ASSETS = {
  // Heroes
  hero_lumetier_main:     { src: `${base}/hero_lumetier_main.png`,     w: 1264, h: 848,  aspect: "wide",   alt: "Editorial maison ensemble in muted cream tones" },
  hero_allure_image_main: { src: `${base}/hero_allure_image_main.png`, w: 848,  h: 1264, aspect: "tall",   alt: "Founder in considered editorial light, full-length portrait" },

  // Portrait / human moments
  editorial_bw_portrait:  { src: `${base}/editorial_bw_portrait.png`,  w: 1024, h: 1024, aspect: "square", alt: "Black-and-white editorial portrait, soft directional light" },
  editorial_couple_warm:  { src: `${base}/editorial_couple_warm.png`,  w: 1264, h: 848,  aspect: "wide",   alt: "Couple in warm afternoon light, candid editorial frame" },
  editorial_maternity:    { src: `${base}/editorial_maternity.png`,    w: 848,  h: 1264, aspect: "tall",   alt: "Maternity portraiture in studio quiet" },
  editorial_back_pose:    { src: `${base}/editorial_back_pose.png`,    w: 848,  h: 1264, aspect: "tall",   alt: "Editorial back-turned pose, sculptural silhouette" },

  // Atelier / scene
  editorial_atelier_scene: { src: `${base}/editorial_atelier_scene.png`, w: 1264, h: 848, aspect: "wide",   alt: "Photographer atelier — lights, props, considered chaos" },
  editorial_studio_wide:   { src: `${base}/editorial_studio_wide.png`,   w: 1264, h: 848, aspect: "wide",   alt: "Wide studio interior, cream backdrop and morning light" },

  // Detail / motion
  editorial_detail_hands: { src: `${base}/editorial_detail_hands.png`, w: 1024, h: 1024, aspect: "square", alt: "Close-up of hands at work — quiet craftsmanship detail" },
  editorial_fabric_motion: { src: `${base}/editorial_fabric_motion.png`, w: 1264, h: 848, aspect: "wide", alt: "Fabric mid-motion, painterly editorial study" },
};

// Convenience accessor — returns `{src, w, h, aspect, alt}` or a graceful
// fallback (the wide studio) for typos and missing slugs in dev.
export function asset(slug) {
  return EDITORIAL_ASSETS[slug] || EDITORIAL_ASSETS.editorial_studio_wide;
}

export default EDITORIAL_ASSETS;
